var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeMedico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 50.5V44.45C45 38.4 40.3 34.09 34 32.53L30.33 31.61C30.33 35.66 27.05 38.94 23 38.94C18.95 38.94 15.67 35.66 15.67 31.61L12 32.53C5.7 34.09 1 38.4 1 44.45V50.5H45Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 9.62H17.5C14.48 9.62 12 12.09 12 15.12C12 22.21 17.61 27.95 23 27.95C28.39 27.95 34 22.2 34 15.12C34 12.09 31.52 9.62 28.5 9.62Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5819 27.95V26.6C26.1319 27.45 24.5519 27.95 23.0019 27.95C21.4519 27.95 19.8719 27.46 18.4219 26.6V27.95C18.4219 29.98 17.1919 31.62 15.6719 31.62C15.6719 35.67 18.9519 50.5 23.0019 50.5C27.0519 50.5 30.3319 35.67 30.3319 31.62C28.8119 31.62 27.5819 29.98 27.5819 27.95V27.95Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9981 15.12C33.9981 12.09 31.5181 9.62001 28.4981 9.62001H17.4981C14.4781 9.62001 11.9981 12.09 11.9981 15.12C11.9981 15.12 9.58809 2.56001 19.4481 1.92001C22.1881 1.74001 25.7781 4.29001 28.8781 4.29001C31.9781 4.29001 33.9981 1.01001 33.9981 1.01001V15.12Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0517 32.77C10.2017 34.56 9.76172 36.46 9.76172 38.41C8.10172 38.44 6.76172 39.79 6.76172 41.46V45.46H6.81172V45.51H7.81172V45.41H6.86172V41.46C6.86172 39.83 8.18172 38.51 9.81172 38.51C11.4417 38.51 12.7617 39.83 12.7617 41.46V45.41H11.8117V45.51H12.8117V45.46H12.8617V41.46C12.8617 39.8 11.5217 38.44 9.86172 38.42C9.86172 36.48 10.3017 34.6 11.1417 32.82C12.5417 29.88 14.9517 27.58 17.9217 26.33L17.8817 26.24C14.8817 27.5 12.4617 29.82 11.0517 32.78V32.77Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9598 32.77C33.5498 29.81 31.1198 27.49 28.1298 26.23L28.0898 26.32C31.0598 27.57 33.4698 29.87 34.8698 32.81C35.7198 34.6 36.1598 36.5 36.1598 38.45H36.2598C36.2598 36.48 35.8198 34.57 34.9698 32.77H34.9598Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1992 43.45C37.5799 43.45 38.6992 42.3307 38.6992 40.95C38.6992 39.5693 37.5799 38.45 36.1992 38.45C34.8185 38.45 33.6992 39.5693 33.6992 40.95C33.6992 42.3307 34.8185 43.45 36.1992 43.45Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 51.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMedico);
export default __webpack_public_path__ + "static/media/icone-medico.a80e94b1dc7fe39e261371efb9f0da51.svg";
export { ForwardRef as ReactComponent };